import apiService from '@common/services/api.service';
import { API } from '@common/services/config';

export default {
    getCities(date, region) {
        const config = {
            params: {
                date,
                region,
            }
        }
        return apiService.lotte.get(API.CITIES, config);
    },
    getRelease(id, date) {
        const config = {
            params: {
                id,
                date,
            }
        }
        return apiService.lotte.get(API.RELEASE, config);
    }
}
